import { cn } from "@devhop/ui";
import type { FeedProductMonitorVariant } from "../api/types";
import { MonitorAnimatedValue } from "./MonitorAnimatedValue";
import { formatKip } from "./table-helpers";

/** จอคนไลฟ์แสดง SKU ทั้งหมดพร้อมกัน โดยเรียงการ์ดสั้นตามพื้นที่จริง */
export function MonitorDisplayVariants({
  variants,
}: {
  variants: FeedProductMonitorVariant[];
}) {
  const singleVariant = variants.length === 1;
  return (
    <div className="@container/monitor-variants border-t p-2">
      <ul
        aria-label="ຕົວເລືອກສິນຄ້າທີ່ກຳລັງສະແດງ"
        className={`grid grid-cols-1 items-start gap-1.5 ${variants.length > 1 ? "@[19rem]/monitor-variants:grid-cols-2 @[46rem]/monitor-variants:grid-cols-3" : ""}`}
      >
        {variants.map((variant) => {
          const sale = variant.saleDetails;
          return (
            <li
              key={variant.sessionProductId}
              className={cn(
                "min-w-0 rounded-md bg-muted/40 px-2 py-1 text-sm leading-5",
                singleVariant &&
                  "@[24rem]/monitor-variants:grid @[24rem]/monitor-variants:grid-cols-[minmax(0,1fr)_auto_auto] @[24rem]/monitor-variants:items-center @[24rem]/monitor-variants:gap-x-6 @[24rem]/monitor-variants:px-3 @[24rem]/monitor-variants:py-2",
              )}
            >
              <div
                className={cn(
                  "flex min-w-0 flex-wrap items-baseline gap-x-1.5",
                  singleVariant &&
                    "@[24rem]/monitor-variants:flex-col @[24rem]/monitor-variants:items-start",
                )}
              >
                <strong className="break-all font-mono text-lg leading-6">
                  {variant.cfCode}
                </strong>
                <span className="min-w-0 break-words text-muted-foreground">
                  {variant.variantLabel}
                </span>
              </div>
              {sale && (
                <div
                  className={cn(
                    "flex flex-wrap items-baseline gap-x-1.5 tabular-nums",
                    singleVariant &&
                      "@[24rem]/monitor-variants:col-start-2 @[24rem]/monitor-variants:flex-col @[24rem]/monitor-variants:items-end @[24rem]/monitor-variants:text-right",
                  )}
                >
                  <strong className="break-words text-base leading-5">
                    {formatKip(sale.salePrice)}
                  </strong>
                  {sale.salePrice < sale.price && (
                    <s className="text-muted-foreground">
                      {formatKip(sale.price)}
                    </s>
                  )}
                </div>
              )}
              <div
                className={cn(
                  "flex flex-wrap items-baseline justify-between gap-x-2",
                  singleVariant &&
                    "@[24rem]/monitor-variants:col-start-3 @[24rem]/monitor-variants:flex-col @[24rem]/monitor-variants:items-end @[24rem]/monitor-variants:text-right",
                )}
              >
                {sale && !sale.saleEnabled && (
                  <span className="font-medium text-destructive">ປິດຂາຍ</span>
                )}
                {sale?.isPreorder ? (
                  <span>Preorder</span>
                ) : (
                  <span
                    className={cn(
                      "inline-flex flex-wrap items-baseline gap-1",
                      singleVariant &&
                        "@[24rem]/monitor-variants:flex-col @[24rem]/monitor-variants:items-end @[24rem]/monitor-variants:gap-0",
                    )}
                  >
                    <span className="text-muted-foreground">ຄົງເຫຼືອ</span>
                    <MonitorAnimatedValue
                      value={String(variant.sessionRemaining ?? "ບໍ່ຈຳກັດ")}
                      enabled
                      className="font-semibold"
                    />
                  </span>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
